import * as React from 'react';

import { StickyFooter } from '../../../components/StickyFooter';
import { Button, useDeviceType } from '@cian/ui-kit';
import { selectIsReferralStickyScrollBtnVisible } from '../../../selectors';
import { useDispatch, useSelector } from 'react-redux';
import { setReferralModalFormOpen } from '../../../slices';
import { trackGetConsultationClick, trackGetTicketClick } from './tracking';

export const StickyFooterContainer: React.FC = () => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const isStickyBtnVisible = useSelector(selectIsReferralStickyScrollBtnVisible);

  const handleModalOpenClick = React.useCallback(
    (source: 'consultation' | 'ticket') => {
      dispatch(setReferralModalFormOpen(source));
    },
    [dispatch],
  );

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyFooter
      title="Не тратьте время — доверьтесь профи"
      isDesktop={isDesktop}
      primaryButton={
        <Button
          theme="fill_primary"
          size={isDesktop ? 'L' : 'M'}
          onClick={() => {
            trackGetTicketClick();
            handleModalOpenClick('ticket');
          }}
          fullWidth={!isDesktop}
        >
          Оставить заявку
        </Button>
      }
      secondaryButton={
        <Button
          theme="fill_secondary"
          size={isDesktop ? 'L' : 'M'}
          onClick={() => {
            trackGetConsultationClick();
            handleModalOpenClick('consultation');
          }}
          fullWidth={!isDesktop}
        >
          Получить консультацию
        </Button>
      }
    />
  );
};
